import { useCallback } from "react";
import { useQueryClient } from "react-query";
import { useDispatch } from "react-redux";
import type { ThunkDispatchType } from "src/app/reducers/IMainAppState";
import { InvalidateAuthenticationToken } from "src/authentication/actions/AuthenticationActionCreator";
import { useAuthenticationToken } from "src/authentication/hooks/useAuthenticationToken";
import { useRemoveAuthenticationToken } from "src/authentication/hooks/useRemoveAuthenticationToken";

export const useLogout = () => {
  const dispatch = useDispatch<ThunkDispatchType>();
  const authenticationToken = useAuthenticationToken();
  const removeAuthenticationToken = useRemoveAuthenticationToken();
  const queryClient = useQueryClient();
  return useCallback(async () => {
    removeAuthenticationToken();
    queryClient.clear();

    if (authenticationToken) {
      dispatch(InvalidateAuthenticationToken(authenticationToken))
        .then(() => undefined)
        .catch(() => undefined);
    }
  }, [authenticationToken, dispatch, queryClient, removeAuthenticationToken]);
};
